import React, { useState, useEffect } from "react";
import { MoonLoader } from "react-spinners";
import HeaderBanner from "./components/HeaderBanner/HeaderBanner";
import MatchList from "./components/MatchList/MatchList";
import DayFilter from "./components/FilterSection/DayFilter/DayFilter";
import ClubFilter from "./components/FilterSection/ClubFilter/ClubFilter";
import { useLeagueMatches } from "../../hooks/matchHooks/useMatchData";
import clubInfo from "../../static/clubInfo";
import { useScrollGameday } from "../../hooks/matchHooks/useScrollGameday";
import { useMatchFilters } from "./hooks/useMatchFilters";
import "./SpielePage.css";




const SpielePage = () => {
  const [allMatches, setAllMatches] = useState([]);
  const [matchDays, setMatchDays] = useState([]);
  const [clubList, setClubList] = useState([]);

  const { displayMatches, dayFilter, clubFilter,  filterByClub, setDisplayMatches, setDayFilter, setClubFilter } = useMatchFilters(allMatches);

  const { scrollToGameday } = useScrollGameday();

  const { data:matches, isLoading } = useLeagueMatches();

    
  // Set up data after loading is complete
  useEffect(() => {
    if (!isLoading) {
      setAllMatches(matches);
      setDisplayMatches(matches);

      // Set up derived data
      setMatchDays([...new Set(matches.map((match) => match.gameday))]);
      setClubList([...new Set(matches.map((match) => match.home_team))].sort());
      setClubFilter(null);
      setDayFilter(null);
      setTimeout(() => scrollToGameday(matches), 100); //Delay to ensure the DOM is ready
    }
  }, [isLoading, scrollToGameday, matches]);


  // Group matches by gameday
  const matchesGroupedByGameday = matchDays
    .filter((day) => displayMatches.some((match) => match.gameday === day))
    .sort((a, b) => a - b)
    .map((day) => ({
      day,
      matches: displayMatches.filter((match) => match.gameday === day),
    }));
  if (isLoading) {
    return (
<div className="spiele-page">
      <div className="spiele-page__selection">
        <HeaderBanner
          dayFilter={dayFilter}
          clubFilter={clubFilter}
        />
        <div className="spiele-page__filter-section-container">
      <MoonLoader color="#36d7b7" size={50} />
        </div>
      </div>
    </div>
    );
  }
  return (
    <div className="spiele-page">
      <div className="spiele-page__selection">
        <HeaderBanner
          dayFilter={dayFilter}
          clubFilter={clubFilter}
        />
        <div className="spiele-page__filter-section-container">
          <div className="spiele-page__filter-section">
            <DayFilter
              setClubFilter={setClubFilter}
              setDayFilter={setDayFilter}
              setDisplayMatches={setDisplayMatches}
              allMatches={allMatches}
              matchDays={matchDays}
            />
            <ClubFilter 
              clubList={clubList}
              allMatches={allMatches}
              setDisplayMatches={setDisplayMatches}
              setDayFilter={setDayFilter}
              setClubFilter={setClubFilter}
              clubInfo={clubInfo}
              filterByClub={filterByClub}
            />
          </div>
        </div>
      </div>
      <MatchList
        matchesGroupedByGameday={matchesGroupedByGameday}
      />
    </div>
  );
};

export default SpielePage;

